import { status } from '@/alas';
import { defineComponent, ref, onMounted, computed } from '@vue/composition-api';
export default defineComponent({
    props: {
        farm: {},
        mode: {
            default: 'create'
        }
    },
    setup(props) {
        // ================
        //
        // refs
        //
        let map = ref(null);
        let zoom = ref(6.5);
        let config = ref(status.fetch('config'));
        // ================
        //
        // methods
        //
        let points = computed(() => {
            if (props.farm.latitude && props.farm.longitude) {
                return [
                    {
                        lat: props.farm.latitude,
                        lng: props.farm.longitude,
                        radius: Number(props.farm.radius || 0)
                    }
                ];
            }
            else {
                return [];
            }
        });
        // ================
        //
        // mounted
        //
        onMounted(() => {
            if (props.farm.latitude && props.farm.longitude) {
                map.value.setCenter(props.farm.latitude, props.farm.longitude);
            }
            if (props.mode !== 'update' && window.navigator.geolocation) {
                window.navigator.geolocation.getCurrentPosition(position => {
                    setMarker({
                        latlng: {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        }
                    });
                });
            }
        });
        // ================
        //
        // methods
        //
        let addMetadata = () => {
            props.farm.metadata.write({
                type: '',
                link: '',
                content: ''
            });
        };
        let setMarker = (data) => {
            if (props.mode === 'create') {
                props.farm.latitude = data.latlng.lat;
                props.farm.longitude = data.latlng.lng;
                map.value.setCenter(data.latlng.lat, data.latlng.lng);
                setTimeout(() => {
                    zoom.value = 12;
                }, 250);
            }
        };
        // ================
        //
        // done
        //
        return {
            map,
            zoom,
            config,
            points,
            addMetadata,
            setMarker
        };
    }
});
